///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthConfigProperties } from '../../services/logical-topology/config-properties.model';
import { AutoDesignPtMpModel } from '../../services/logical-topology/design/auto-design-ptmp.model';
import { Validators } from '@angular/forms';
import { GtthAdvancedConfigComponent } from './advanced_plan/advanced-config.component';
import { GtthManualDesignComponent } from './manual-design/manual-design.component';

export const initReactiveControlsForLayer = (dialogComp, layerIdx: number, layerHasMhTG: boolean): void => {
    dialogComp.capFacPerLayer[layerIdx] = GtthConfigProperties.getCapFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].cap_fac,
        layerHasMhTG
    );

    dialogComp.lcentDistPerLayer[layerIdx] = GtthConfigProperties.getLcentDistField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].lcent_dist,
        layerHasMhTG
    );

    dialogComp.limBoxesPerLayer[layerIdx] = GtthConfigProperties.getLimBoxesField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].lim_boxes
    );

    dialogComp.peerBsFacPerLayer[layerIdx] = GtthConfigProperties.getPeerBsFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].peer_bs_fac
    );

    dialogComp.redunFacPerLayer[layerIdx] = GtthConfigProperties.getRedunFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].redun_fac
    );

    dialogComp.tunnelFacPerLayer[layerIdx] = GtthConfigProperties.getTunnelFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].tunnel_fac
    );

    dialogComp.asMethodPerLayer[layerIdx] = GtthConfigProperties.getAsMethodField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].as_method
    );

    dialogComp.popDistFacPerLayer[layerIdx] = GtthConfigProperties.getPopDistFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].pop_dist_fac,
        layerHasMhTG
    );

    dialogComp.maxDevNumPerLayer[layerIdx] = GtthConfigProperties.getMaxDevNumField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].max_dev_num
    );

    dialogComp.takeRatePerLayer[layerIdx] = GtthConfigProperties.getTakeRateField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].take_rate
    );

    dialogComp.costFacPerLayer[layerIdx] = GtthConfigProperties.getCostFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].cost_fac
    );

    dialogComp.nCandWinPerLayer[layerIdx] = GtthConfigProperties.getNCandWinField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].n_cand_win
    );

    dialogComp.tgMaxIttrPerLayer[layerIdx] = GtthConfigProperties.getTgMaxIttrField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].tg_max_ittr
    );

    dialogComp.p2pDistFacPerLayer[layerIdx] = GtthConfigProperties.getP2PDistFacField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].p2p_dist_fac
    );

    dialogComp.optBsFacPerLayer[layerIdx] = GtthConfigProperties.getOptBsFactorField(
        dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].opt_bs_fac
    );
};

export const updateReactiveFormForLayer = (dialogComp, layerIdx: number): void => {
    // update min values & validators of tunnel factor and redundancy factor fields
    dialogComp.editForm
        .get(dialogComp.capFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].cap_fac);

    dialogComp.editForm
        .get(dialogComp.lcentDistPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].lcent_dist);

    dialogComp.editForm
        .get(dialogComp.limBoxesPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].lim_boxes);

    dialogComp.editForm
        .get(dialogComp.peerBsFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].peer_bs_fac);

    dialogComp.editForm
        .get(dialogComp.redunFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].redun_fac);

    dialogComp.editForm
        .get(dialogComp.tunnelFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].tunnel_fac);

    dialogComp.editForm
        .get(dialogComp.asMethodPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].as_method);

    dialogComp.editForm
        .get(dialogComp.popDistFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].pop_dist_fac);

    dialogComp.editForm
        .get(dialogComp.maxDevNumPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].max_dev_num);

    dialogComp.editForm
        .get(dialogComp.takeRatePerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].take_rate);

    dialogComp.editForm
        .get(dialogComp.costFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].cost_fac);

    dialogComp.editForm
        .get(dialogComp.nCandWinPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].n_cand_win);

    dialogComp.editForm
        .get(dialogComp.tgMaxIttrPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].tg_max_ittr);

    dialogComp.editForm
        .get(dialogComp.p2pDistFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].p2p_dist_fac);

    dialogComp.editForm
        .get(dialogComp.optBsFacPerLayer[layerIdx].key)
        .setValue(dialogComp.historyService.logicalTopology.autodesignP2mpPerLayer[layerIdx].opt_bs_fac);
};

export const updateTunnelAndRedundancyFactorFields = (
    dialogComp: GtthAdvancedConfigComponent | GtthManualDesignComponent,
    layerIdx: number
): void => {
    // update min values & validators of tunnel factor and redundancy factor fields on enable/disable resiliency feature
    const tunnelFacControl = dialogComp.editForm.get(dialogComp.tunnelFacPerLayer[layerIdx].key);
    const redunFacControl = dialogComp.editForm.get(dialogComp.redunFacPerLayer[layerIdx].key);
    const peerBsFactorControl = dialogComp.editForm.get(dialogComp.peerBsFacPerLayer[layerIdx].key);
    if (dialogComp.resiliencyEnabled[layerIdx]) {
        const newTunnelFacDefaultValue = dialogComp.layerContainsMhTgBu[layerIdx]
            ? AutoDesignPtMpModel.TUNNEL_FAC_DEFAULT_VALUE_FOR_MH_TG
            : AutoDesignPtMpModel.TUNNEL_FAC_DEFAULT_VALUE_FOR_NON_MH_TG;

        const newTunnelFacMinValue = dialogComp.layerContainsMhTgBu[layerIdx]
            ? AutoDesignPtMpModel.TUNNEL_FAC_DEFAULT_VALUE_FOR_MH_TG
            : AutoDesignPtMpModel.TUNNEL_FAC_MIN_VALUE_FOR_NO_RESILIENCY;
        dialogComp.tunnelFacPerLayer[layerIdx].min = newTunnelFacMinValue;
        dialogComp.tunnelFacPerLayer[layerIdx].value = newTunnelFacDefaultValue;
        tunnelFacControl.setValidators(
            Validators.compose([
                Validators.required,
                Validators.min(newTunnelFacMinValue),
                Validators.max(dialogComp.tunnelFacPerLayer[layerIdx].max)
            ])
        );
        tunnelFacControl.setValue(newTunnelFacDefaultValue);
        tunnelFacControl.markAsDirty();

        dialogComp.redunFacPerLayer[layerIdx].min = AutoDesignPtMpModel.REDUND_FAC_FOR_RESILIENCY;
        dialogComp.redunFacPerLayer[layerIdx].value = AutoDesignPtMpModel.REDUND_FAC_FOR_RESILIENCY;
        redunFacControl.setValidators(
            Validators.compose([
                Validators.required,
                Validators.min(AutoDesignPtMpModel.REDUND_FAC_FOR_RESILIENCY),
                Validators.max(dialogComp.tunnelFacPerLayer[layerIdx].max)
            ])
        );
        redunFacControl.setValue(AutoDesignPtMpModel.REDUND_FAC_FOR_RESILIENCY);
        redunFacControl.markAsDirty();

        peerBsFactorControl.setValue(0.3);
        peerBsFactorControl.enable();
        peerBsFactorControl.markAsDirty();
        dialogComp.peerBsFacPerLayer[layerIdx].value = 0.3;
    } else {
        dialogComp.tunnelFacPerLayer[layerIdx].min = AutoDesignPtMpModel.TUNNEL_FAC_MIN_VALUE_FOR_NO_RESILIENCY;
        dialogComp.tunnelFacPerLayer[layerIdx].value = AutoDesignPtMpModel.TUNNEL_FAC_DEFAULT_VALUE_FOR_NO_RESILIENCY;
        tunnelFacControl.setValidators(
            Validators.compose([
                Validators.required,
                Validators.min(AutoDesignPtMpModel.TUNNEL_FAC_MIN_VALUE_FOR_NO_RESILIENCY),
                Validators.max(dialogComp.tunnelFacPerLayer[layerIdx].max)
            ])
        );
        tunnelFacControl.setValue(AutoDesignPtMpModel.TUNNEL_FAC_DEFAULT_VALUE_FOR_NO_RESILIENCY);
        tunnelFacControl.markAsDirty();

        dialogComp.redunFacPerLayer[layerIdx].min = AutoDesignPtMpModel.REDUND_FAC_FOR_NO_RESILIENCY;
        dialogComp.redunFacPerLayer[layerIdx].value = AutoDesignPtMpModel.REDUND_FAC_FOR_NO_RESILIENCY;
        redunFacControl.setValidators(
            Validators.compose([
                Validators.required,
                Validators.min(AutoDesignPtMpModel.REDUND_FAC_FOR_NO_RESILIENCY),
                Validators.max(dialogComp.tunnelFacPerLayer[layerIdx].max)
            ])
        );
        redunFacControl.setValue(AutoDesignPtMpModel.REDUND_FAC_FOR_NO_RESILIENCY);
        redunFacControl.markAsDirty();

        peerBsFactorControl.setValue(0);
        peerBsFactorControl.disable();
        peerBsFactorControl.markAsDirty();
        dialogComp.peerBsFacPerLayer[layerIdx].value = 0;
    }
};
